
import { participantInstance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

 //call the api for get recent list of inventories,evaluations and followups 
async function getRecentList(service) {

  const api =
    url +
    `/participants/recent_response_targets?service=${service}`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
 //call the api for get list of inventories
async function getInventoryList(page,limit,filter) {

  const api =
    url +
    `/participants/inventories?page=${page}&filter=${filter}&limit=${limit}`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

 //call the api for get list of inventories
 async function getEvaluationList(page,limit,filter) {

  const api =
    url +
    `/participants/evaluations?page=${page}&filter=${filter}&limit=${limit}`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function participantchangePassword(data) {
  //call the api for changing password

  const api = url + `/participants/change-password/v1`;


  return await participantInstance
    .post(api, data)
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false, password reset  fails
      return error;
    });
}

async function getFollowupList(page,limit,filter) {

  const api =
    url +
    `/participants/followups?page=${page}&filter=${filter}&limit=${limit}`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
export const participantDashboardService = {
  getRecentList,
  getInventoryList,
  getEvaluationList,
  participantchangePassword,
  getFollowupList
};
